import { exportToBlob } from "@excalidraw/excalidraw";
import type { ExcalidrawImperativeAPI } from "@excalidraw/excalidraw/types";

const BACKEND_GET = import.meta.env.VITE_APP_BACKEND_V2_GET_URL;

export async function uploadThumbnail(id: string, api: ExcalidrawImperativeAPI): Promise<void> {
  const blob = await exportToBlob({
    elements: api.getSceneElements(),
    appState: { ...api.getAppState(), exportBackground: true },
    files: api.getFiles(),
    mimeType: "image/png",
    exportPadding: 20,
  });
  await fetch(`${BACKEND_GET}${id}/thumb`, {
    method: "POST",
    body: blob,
    headers: { "Content-Type": "image/png" },
  });
}
